import { StatMetric } from "../../dashboard/components/Metric";
import { useApplicationMetrics } from "@/hooks/useApplicationMetrics";

export function ApplicationOverview() {
  const metrics = useApplicationMetrics();

  return (
    <>
      <h2 className="mb-2 w-full text-2xl font-semibold">Application Overview</h2>
      <div className="flex flex-wrap gap-4">
        {metrics.map((metric, index) => (
          <StatMetric
            key={index}
            statValue={metric.statValue}
            metricTitle={metric.metricTitle}
            icon={metric.icon}
            iconColor={metric.iconColor}
            iconBgColor={metric.iconBgColor}
            isLoading={metric.isLoading}
          />
        ))}
      </div>
    </>
  );
}
